import React, { useState, useEffect } from 'react'
import axios from 'axios'
import {
  TextField,
  // Checkbox
} from '@material-ui/core'
import Autocomplete from '@material-ui/lab/Autocomplete'
// import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank'
// import CheckBoxIcon from '@material-ui/icons/CheckBox'
import { useDispatch } from 'react-redux'
import { checkErrorStatus, setSnackbar } from 'utils/common/actions'
import { getIdArray } from 'helpers/dataHelpers'
import useStyles from './styles'
import Config from 'config'


// const icon = <CheckBoxOutlineBlankIcon fontSize='small' />
// const checkedIcon = <CheckBoxIcon fontSize='small' />


const LawsInput = (props) => {
  const localClasses = useStyles()
  const {
    error,
    helperText,
    setValue,
    defaultValue,
    single,
    variant,
    notRequired,
    additionalClasses,
    getValue,
    valueLaws,
    countries,
    noOptionsText
  } = props
  const { apiUrl } = Config.network
  const dispatch = useDispatch()
  const [laws, setLaws] = useState([])
  const [localValue, setLocalValue] = useState(single ? null : [])
  const [inputValue, setInputValue] = React.useState('')

  const getLaws = () => {
    const url = `${apiUrl}laws/get_simple_list/`
    const params = {}
    if (countries && countries.length > 0) {
      params['countries'] = countries.join()
    } else {
      params['countries'] = 'NO_COUNTRIES'
    }
    axios.get(url, { params }).then((body) => {
      const { data } = body
      setLaws(data)
    }).catch(error => {
      if (error.response) {
        dispatch(checkErrorStatus(error.response.status))
      } else {
        dispatch(setSnackbar('Connection error', 'error'))
      }
    })
  }

  useEffect(() => {
    getLaws()
    if (defaultValue) {
      if (!single) {
        setValue(getIdArray(defaultValue))
      } else {
        setValue(defaultValue)
      }
    }
  }, [countries]) // eslint-disable-line react-hooks/exhaustive-deps


// TO DO: Optimize this function
  const handleChange = (event, newValue) => {
    setLocalValue(newValue)
    if (single) {
      if (getValue) {
        if (newValue) {
          getValue('create', newValue)
        }
        setLocalValue(null)
        setInputValue('')
      } else {
        setValue(newValue)
      }
    } else {
      if (getValue) {
        if (newValue) {
          getValue('create', newValue)
        }
      } else {
        setValue(getIdArray(newValue))
      }
    }
  }

  const setDefaultValue = () => {
    if (defaultValue) {
      return defaultValue
    }
    if (single) {
      return null
    }
    return []
  }

  return (
    <Autocomplete
      value={localValue}
      onChange={handleChange}
      inputValue={inputValue}
      onInputChange={(event, newInputValue) => {
        setInputValue(newInputValue)
      }}
      getOptionSelected={(option, value) => option.id === value.id}
      multiple={!single}
      options={laws}
      className={`${localClasses.lawsAutocomlete} ${additionalClasses || ''}`}
      autoHighlight
      fullWidth
      defaultValue={setDefaultValue()}
      getOptionLabel={(law) => law.short_name}
      getOptionDisabled={valueLaws ? (law) => valueLaws.indexOf(law.id) !== -1 : () => false}
      renderOption={(law) => (
        <React.Fragment>
          {law.short_name} {law.articles}
        </React.Fragment>
      )}
      noOptionsText={noOptionsText || 'No options'}
      renderInput={(params) => (
        <TextField
          {...params}
          placeholder='Search in Applicable laws'
          variant={variant || 'outlined'}
          fullWidth
          required={!notRequired}
          error={error}
          helperText={helperText}
          name='laws'
          color='secondary'
        />
      )}
    />
  )
}

export default LawsInput
